

          
          window.Fandango.templates = window.Fandango.templates || {};
          window.Fandango.templates._theatersPlaceholder = function anonymous(_swig,_ctx,_filters,_utils,_fn
) {
  var _imports = {};
  var _ext = _swig.extensions,
    _output = "";
(function () {
  var __l = ((typeof _ctx.Array !== "undefined") ? _ctx.Array : ((typeof Array !== "undefined") ? Array : _fn))(3), __len = (_utils.isArray(__l) || typeof __l === "string") ? __l.length : _utils.keys(__l).length;
  if (!__l) { return; }
    var _ctx__loopcache157c2477eb47cec4c47da0bdb8f0291e = { loop: _ctx.loop, x: _ctx.x, __k: _ctx.__k };
    _ctx.loop = { first: false, index: 1, index0: 0, revindex: __len, revindex0: __len - 1, length: __len, last: false };
  _utils.each(__l, function (x, __k) {
    _ctx.x = x;
    _ctx.__k = __k;
    _ctx.loop.key = __k;
    _ctx.loop.first = (_ctx.loop.index0 === 0);
    _ctx.loop.last = (_ctx.loop.revindex0 === 0);
    _output += "\n    <div class=\"concessions-theater-placeholder__header theaters-module__theater-item--placeholder\"></div>\n    <ol class=\"concessions-theater-placeholder__theater-list\">\n        ";
if ((((typeof _ctx.isMobile !== "undefined" && _ctx.isMobile !== null) ? ((typeof _ctx.isMobile !== "undefined" && _ctx.isMobile !== null) ? _ctx.isMobile : "") : ((typeof isMobile !== "undefined" && isMobile !== null) ? isMobile : "")) !== null ? ((typeof _ctx.isMobile !== "undefined" && _ctx.isMobile !== null) ? ((typeof _ctx.isMobile !== "undefined" && _ctx.isMobile !== null) ? _ctx.isMobile : "") : ((typeof isMobile !== "undefined" && isMobile !== null) ? isMobile : "")) : "" )) { 
_output += "\n            ";
(function () {
  var __l = ((typeof _ctx.Array !== "undefined") ? _ctx.Array : ((typeof Array !== "undefined") ? Array : _fn))(4), __len = (_utils.isArray(__l) || typeof __l === "string") ? __l.length : _utils.keys(__l).length;
  if (!__l) { return; }
    var _ctx__loopcachefc1598a32cfb65c5f4a2ee63346fc8ad = { loop: _ctx.loop, x: _ctx.x, __k: _ctx.__k };
    _ctx.loop = { first: false, index: 1, index0: 0, revindex: __len, revindex0: __len - 1, length: __len, last: false };
  _utils.each(__l, function (x, __k) {
    _ctx.x = x;
    _ctx.__k = __k;
    _ctx.loop.key = __k;
    _ctx.loop.first = (_ctx.loop.index0 === 0);
    _ctx.loop.last = (_ctx.loop.revindex0 === 0);
    _output += "\n                <li>\n                    <div class=\"concessions-theater-placeholder__movie-post theaters-module__theater-item--placeholder\"></div>\n                    <div class=\"concessions-theater-placeholder__movie-name theaters-module__theater-item--placeholder\"></div>\n                    <div class=\"concessions-theater-placeholder__movie-description theaters-module__theater-item--placeholder\"></div>\n                </li>\n            ";
    _ctx.loop.index += 1; _ctx.loop.index0 += 1; _ctx.loop.revindex -= 1; _ctx.loop.revindex0 -= 1;
  });
  _ctx.loop = _ctx__loopcachefc1598a32cfb65c5f4a2ee63346fc8ad.loop;
  _ctx.x = _ctx__loopcachefc1598a32cfb65c5f4a2ee63346fc8ad.x;
  _ctx.__k = _ctx__loopcachefc1598a32cfb65c5f4a2ee63346fc8ad.__k;
  _ctx__loopcachefc1598a32cfb65c5f4a2ee63346fc8ad = undefined;
})();
_output += "\n        ";
} else {
_output += "\n            ";
(function () {
  var __l = ((typeof _ctx.Array !== "undefined") ? _ctx.Array : ((typeof Array !== "undefined") ? Array : _fn))(8), __len = (_utils.isArray(__l) || typeof __l === "string") ? __l.length : _utils.keys(__l).length;
  if (!__l) { return; }
    var _ctx__loopcachefc1598a32cfb65c5f4a2ee63346fc8ad = { loop: _ctx.loop, x: _ctx.x, __k: _ctx.__k };
    _ctx.loop = { first: false, index: 1, index0: 0, revindex: __len, revindex0: __len - 1, length: __len, last: false };
  _utils.each(__l, function (x, __k) {
    _ctx.x = x;
    _ctx.__k = __k;
    _ctx.loop.key = __k;
    _ctx.loop.first = (_ctx.loop.index0 === 0);
    _ctx.loop.last = (_ctx.loop.revindex0 === 0);
    _output += "\n                <li>\n                    <div class=\"concessions-theater-placeholder__movie-post theaters-module__theater-item--placeholder\"></div>\n                    <div class=\"concessions-theater-placeholder__movie-name theaters-module__theater-item--placeholder\"></div>\n                    <div class=\"concessions-theater-placeholder__movie-description theaters-module__theater-item--placeholder\"></div>\n                </li>\n            ";
    _ctx.loop.index += 1; _ctx.loop.index0 += 1; _ctx.loop.revindex -= 1; _ctx.loop.revindex0 -= 1;
  });
  _ctx.loop = _ctx__loopcachefc1598a32cfb65c5f4a2ee63346fc8ad.loop;
  _ctx.x = _ctx__loopcachefc1598a32cfb65c5f4a2ee63346fc8ad.x;
  _ctx.__k = _ctx__loopcachefc1598a32cfb65c5f4a2ee63346fc8ad.__k;
  _ctx__loopcachefc1598a32cfb65c5f4a2ee63346fc8ad = undefined;
})();
_output += "\n        ";

}_output += "\n    </ol>\n";
    _ctx.loop.index += 1; _ctx.loop.index0 += 1; _ctx.loop.revindex -= 1; _ctx.loop.revindex0 -= 1;
  });
  _ctx.loop = _ctx__loopcache157c2477eb47cec4c47da0bdb8f0291e.loop;
  _ctx.x = _ctx__loopcache157c2477eb47cec4c47da0bdb8f0291e.x;
  _ctx.__k = _ctx__loopcache157c2477eb47cec4c47da0bdb8f0291e.__k;
  _ctx__loopcache157c2477eb47cec4c47da0bdb8f0291e = undefined;
})();
_output += "\n";

  return _output;

}
          module.exports = window.Fandango.templates._theatersPlaceholder;
          
          